/* eslint-disable @typescript-eslint/naming-convention */
import { ClassCodeDto } from './ClassCodeDto';
import { ClassRequirementDto } from './ClassRequirementDto';

export interface TradeClassDto {
  TradeClassID: string;
  TradeGroupID: string;
  ClassTypeID: number;
  WorkLocationID: number | null;
  LinkedClassID: string | null;
  TradeClassName: string;
  Level: number;
  bActive: boolean;
  ClassCodesCount: number;
  ClassCodes: ClassCodeDto[];
  ClassRequirements: ClassRequirementDto[];
  ClassTypeName: string;
  WorkLocationName: string;
  LinkedClassName: string;
  Tier: number | null;

  /** Client side only */
  isDirty: boolean;
  /** Client side only */
  isInvalid: boolean;
  /** Client side only */
  isSelected: boolean;
  /** Client side only */
  isChecked: boolean;
  /** Client side only */
  FilteredClassCodes: ClassCodeDto[];
  /** Client side only */
  ClassCodeCount: number;
}
